import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('FixErrorPublicationsDto')
export class FixErrorPublicationsDto {
  @JsonProperty('errorCode', String, true) errorCode: string = undefined;
  @JsonProperty('storeCode', String, true) storeCode: string = undefined;
  @JsonProperty('operation', String, true) operation: string = undefined;

  constructor(errorCode: string, storeCode: string, operation: string) {
    this.errorCode = errorCode;
    this.storeCode = storeCode;
    this.operation = operation;
  }
}
